<div class="login-wrapper">
	@for (bg of backgrounds; track bg; let i = $index) {
	<div
		class="child"
		[class.active]="i === currentBackgroundIndex()"
		[class.visible]="isBackgroundVisible(i)"
		[style.background-image]="'url(' + bg + ')'"></div>
	}

	<div class="login-container">
		<router-outlet />
	</div>
</div>
